import { useEffect, useState } from "react"
import { CBPayInstanceType, initOnRamp } from "@coinbase/cbpay-js"
import CoinbaseLogo from "@components/icons/CoinbaseLogo"
import { useAccount } from "wagmi"
import { Button } from "@components/ui/base/button"
import Check from "../../icons/Check"

type Props = {
  ethTopUpAmount?: number
  usdcTopUpAmount?: number
  mutate?: () => void
}

const PayWithCoinbaseButton = ({
  ethTopUpAmount,
  usdcTopUpAmount,
  mutate
}: Props) => {
  const [onrampInstance, setOnrampInstance] = useState<
    CBPayInstanceType | undefined
  >()
  const [isLoading, setIsLoading] = useState(false)
  const [isPayWithCoinbaseSuccess, setIsPayWithCoinbaseSuccess] =
    useState(false)
  const { address: account } = useAccount()

  useEffect(() => {
    initOnRamp(
      {
        appId: "5ccef000-d63c-40b4-a0ae-54ecd0c6a622",
        widgetParameters: {
          presetCryptoAmount: usdcTopUpAmount,
          // presetFiatAmount: usdcTopUpAmount,
          destinationWallets: [
            {
              address: account,
              assets: ["USDC"],
              blockchains: ["base"]
            }
          ],
          defaultAsset: "USDC",
          defaultNetwork: "base",
          defaultExperience: "buy"
        },
        onSuccess: () => {
          console.log("success")
          setIsPayWithCoinbaseSuccess(true)
          // mutate() // TODO: Handle mutation by tracking transaction https://docs.cloud.coinbase.com/pay-sdk/docs/rest-api-reference#transaction-status
        },
        onExit: (err) => {
          console.log("exit")
          console.log(err)
        },
        onEvent: (event) => {
          console.log("event", event)
        },
        experienceLoggedIn: "embedded",
        experienceLoggedOut: "popup",
        closeOnExit: true,
        closeOnSuccess: true
      },
      (_, instance) => {
        setOnrampInstance(instance)
      }
    )

    return () => {
      onrampInstance?.destroy()
    }
  }, [])

  const handleClick = () => {
    if (onrampInstance) {
      onrampInstance.open()
    } else {
      setIsLoading(true)
    }
  }

  useEffect(() => {
    if (isLoading && onrampInstance) {
      onrampInstance?.open()
      setIsLoading(false)
    }
  }, [isLoading, onrampInstance])

  return !isPayWithCoinbaseSuccess ? (
    <Button
      className="sl-bg-blue-700 hover:sl-bg-blue-900 sl-text-white sl-w-[280px]"
      onClick={handleClick}
      loading={isLoading}
    >
      {!isLoading && (
        <span className="sl-flex sl-items-center sl-gap-x-2">
          <span>Buy with card on Coinbase</span>
          <span className="sl-w-6 sl-h-6">
            <CoinbaseLogo />
          </span>
        </span>
      )}
    </Button>
  ) : (
    <div className="sl-text-left sl-text-green-600">
      <div className="sl-flex sl-items-center sl-gap-1">
        <p className="sl-text-sm sl-font-semibold">Payment successful</p>
        <Check className="sl-w-4 sl-h-4" />
      </div>
      <p className="sl-text-[0.8rem]">
        Wait a few minutes for your balance to update
      </p>
    </div>
  )
}

export default PayWithCoinbaseButton
